import type { ReactNode } from "react";

import { HeroDemoCursorIcon } from "../../hero-demo-cursor-icon";

export type HeroClickPulseDotPlacement =
  | "after-avatar"
  | "inline"
  | "row-end"
  | "corner-tr"
  | "nav-end"
  | "nav-before-badge";

/**
 * Small pulsing green dot plus demo cursor — marks a clickable hero-mock target.
 * Parent must be `position: relative` for absolute placements.
 */
export function HeroClickPulseDot(props: {
  readonly placement?: HeroClickPulseDotPlacement;
}): ReactNode {
  const placement: HeroClickPulseDotPlacement = props.placement ?? "row-end";
  return (
    <span
      aria-hidden
      className={`mkhero-click-pulse-hint mkhero-click-pulse-hint--${placement}`}
    >
      <span
        className={`mkhero-click-pulse-dot mkhero-click-pulse-dot--${placement}`}
      >
        <span className="mkhero-click-pulse-dot-core" />
      </span>
      <span className="mkhero-click-pulse-pointer">
        <span className="mkhero-click-pointer-wrap">
          <span className="mkhero-click-pointer">
            <span className="mkhero-click-pointer-ripple" />
            <HeroDemoCursorIcon size={22} />
          </span>
        </span>
      </span>
    </span>
  );
}
